import { Component } from '@angular/core';
import { Tenant } from '../../../../../express-tRPC/src/api/tenants/types-generic';
import { TableLazyLoadEvent } from 'primeng/table';
import { TrpcService } from '../../services/trpc/trpc.service';
import { MessageService } from 'primeng/api';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-tenant-list',
  templateUrl: './tenant-list.component.html',
  styleUrl: './tenant-list.component.scss'
})
export class TenantListComponent {
  tenants!: Tenant[];
  totalTenants: any;
  isTenantlistLoading: boolean = false;
  env = environment;
  siteUrl = environment.SITE_URL;
  isLPRActive: boolean = false;
  isCheckingLPRStatus: boolean = true;
  
  // Stores the location ID the user is currently signed into
  locationId: string = '';
  
  constructor(
    private trpcService: TrpcService,
    private messageService: MessageService,
  ) {}

  ngOnInit() {
    
    this.trpcService.trpc.lots.getSessionLID.query().then((location: string) => {
      this.locationId = location;
    });

    // Check LPR status before loading tenant list
    this.checkLPRStatus().then(() => {
      if (this.isLPRActive) {
        this.getTenantList();
      }
    });
  }

  async getTenantList() {

    this.isTenantlistLoading = true;
    let tenantsResult: any = await this.trpcService.trpc.tenant_list.getTenants.query().catch((error: any) => {
      this.messageService.add({
        severity: "error",
        detail: error.message,
      });
    });
    this.tenants = tenantsResult;
    // console.log("this.tenants is: " + JSON.stringify(this.tenants));

    let count: any = await this.trpcService.trpc.tenant_list.getTenantsCount.query().catch((error: any) => {
      this.messageService.add({
        severity: "error",
        detail: error.message,
      });
    });
    if(count) {
      const recordCount = Object.values(count[0][0]);
      this.totalTenants = recordCount[0];
      console.log("this.totalTenants is: " + this.totalTenants);
    }

    this.isTenantlistLoading = false;

  }

  async updateTenantStatus(tenantStatus: string, suite: string, account: string, reason: string = '')  {

    // If tenant was pending deactivation so re-enable
    let newStatus: string = 'active';

    if(tenantStatus == '' || tenantStatus == 'show' || tenantStatus == 'active') {
      // Tenant is active and new status should be deactive.
      newStatus = 'pending deactivation';
    }

    this.isTenantlistLoading = true;
    let tenantsResult: any = await this.trpcService.trpc.tenant_list.toggleTenantStatus.mutate({
      status: newStatus,
      suite: suite,
      account: account,
      reason: reason
    }).then(() => {
      this.getTenantList();
    }).catch((error: any) => {
      this.messageService.add({
        severity: "error",
        detail: error.message,
      });
      this.isTenantlistLoading = false;
    });

  }

  async checkLPRStatus() {
    try {
      this.isCheckingLPRStatus = true;
      const result = await this.trpcService.trpc.monthly_invoice.checkLPRStatus.query();
      this.isLPRActive = result.isLPRActive;
    } catch (error: any) {
      console.error('Error checking LPR status:', error);
      // Default to not active if there's an error
      this.isLPRActive = false;
    } finally {
      this.isCheckingLPRStatus = false;
    }
  }
}
